import React from 'react';

import styled from 'styled-components';

import ScoreBar from '../ScoreBar';

const SmallText = styled.span`
  font-size: 12px;
  color: var(--text-secondary);
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 130px;

  .value {
    font-size: 16px;
    color: var(--text-primary);
  }

  .suffix {
    font-size: 12px;
    color: var(--text-secondary);
  }
`;

type Props = {
  score: number | null;
  averageScore: number | null;
};

const ScoreCell = ({ score, averageScore }: Props) => {
  if (typeof score !== 'number') {
    return <SmallText>-</SmallText>;
  }

  const isAboveAvg = averageScore == null || score >= averageScore;

  return (
    <Container>
      <div>
        <span className="value">{score}</span>
        <span className="suffix">/100</span>
      </div>
      <ScoreBar score={score} positive={isAboveAvg} thin />
    </Container>
  );
};

export default ScoreCell;
